<template>
  <form class="form form-register-token" @submit.prevent="postToken">

    <timeline labels="Numer telefonu,Kod SMS,Twoje dane" current="2"></timeline>

    <slide-y-up-transition :duration="500" :delay="200">
      <div v-show="show" class="box-info text-center">Przepisz kod, który wysłaliśmy SMSem na Twój numer telefonu.</div>
    </slide-y-up-transition>

    <slide-x-left-transition :duration="400" :delay="200">
      <div class="form-group" v-show="show">
        <label>Kod SMS</label>
        <div class="input-wrapper">
          <input v-model="form.sms_token"
                 type="number"
                 :class="{'input-error' : errors.sms_token }"
                 placeholder="Podaj kod SMS"
                 ref="smsTokenInput"
                 required/>
        </div>
        <p class="error" v-if="errors.sms_token">{{ errors.sms_token[0] }}</p>
      </div>
    </slide-x-left-transition>

    <ion-button mode="ios" expand="block" type="submit" :disabled="loading">
      <span v-if="loading"><span class="loader"></span></span>
      <span v-else>Dalej</span>
    </ion-button>
  </form>
</template>

<script>
  import Timeline from '@/components/Timeline.vue';
  import { mapState } from 'vuex'

  export default {
    name: 'FormRegisterToken',
    components: { Timeline },
    computed: {
      ...mapState({
        loading: state => state.register.loading,
        errors: state => state.register.errors,
        hash: state => state.register.hash,
        phone_number: state => state.register.phone_number
      })
    },
    data() {
      return {
        show: false,
        form: {
          sms_token : '',
        }
      }
    },
    mounted(){
      this.show = true;
      setTimeout(() => {
        this.$refs.smsTokenInput.focus();
      },1000)
    },
    methods: {
      postToken() {
        let data = {
          'phone_number' : this.phone_number,
          'sms_token' : this.form.sms_token,
          'hash' : this.hash
        }
        this.$store.dispatch('TOKEN_REQUEST', data).then(() => {
          this.$router.push({name: 'RegisterDetails'}).catch(err => {})
          this.$store.dispatch('GLOBAL_TOAST','Weryfikacja poprawna.');
        })
      }
    }
  }
</script>